export const CHANGE_UNITS_FILTER = 'CHANGE_UNITS_FILTER';
export const CHANGE_FILTER_FIELD = 'CHANGE_FILTER_FIELD';
export const RESET_ALL_FILTERS = 'RESET_ALL_FILTERS';
export const RESET_FILTERS = 'RESET_FILTERS';
